import { Box, Button, colors } from "@mui/material";
import { useNavigate } from "react-router";

const NavBar = ({
  isOwner = false,
  auth = false,
}: {
  isOwner?: boolean;
  auth?: boolean;
}) => {
  const navigate = useNavigate();
  return (
    <Box
      display="flex"
      justifyContent="center"
      bgcolor={colors.grey[400]}
      columnGap={1}
    >
      <Button
        sx={{ my: 1 }}
        variant="contained"
        color="primary"
        onClick={() => {
          navigate("/home");
        }}
      >
        Home
      </Button>
      {auth && (
        <>
          {isOwner && (
            <>
              <Button
                sx={{ my: 1 }}
                variant="contained"
                color="warning"
                onClick={() => {
                  navigate("/general");
                }}
              >
                General
              </Button>
              <Button
                sx={{ my: 1 }}
                variant="contained"
                color="secondary"
                onClick={() => {
                  navigate("/khushi");
                }}
              >
                Khushi
              </Button>
              <Button
                sx={{ my: 1 }}
                variant="contained"
                color="secondary"
                onClick={() => {
                  navigate("/jarvis");
                }}
              >
                Jarvis
              </Button>
            </>
          )}
        </>
      )}
    </Box>
  );
};

export default NavBar;
